export enum TemplateEditor {
  SELECT_TEMPLATE_SECTION = "SELECT_TEMPLATE_SECTION",

  REFORM_SECTION_RULES = "REFORM_SECTION_RULES",
  DELETE_SECTION_RULE = "DELETE_SECTION_RULE",
  UPDATE_SECTION_RULE = "UPDATE_SECTION_RULE",

  UPDATE_SECTION = "UPDATE_SECTION",
  UPDATE_SECTION_SUCCESS = "UPDATE_SECTION_SUCCESS",
  UPDATE_SECTION_FAIL = "UPDATE_SECTION_FAIL",

  GET_PARAMETERS = "GET_PARAMETERS",
  GET_PARAMETERS_SUCCESS = "GET_PARAMETERS_SUCCESS",
  GET_PARAMETERS_FAIL = "GET_PARAMETERS_FAIL",
  RESET_PARAMETERS_SUCCESS = "RESET_PARAMETERS_SUCCESS",

  GET_SECTIONS = "GET_SECTIONS",
  GET_SECTIONS_SUCCESS = "GET_SECTIONS_SUCCESS",
  GET_SECTIONS_FAIL = "GET_SECTIONS_FAIL",
  SAVE_SECTIONS = "SAVE_SECTIONS",

  GET_REPEATING_ADAPTER_TOKENS = "GET_REPEATING_ADAPTER_TOKENS",
  GET_REPEATING_ADAPTER_TOKENS_SUCCESS = "GET_REPEATING_ADAPTER_TOKENS_SUCCESS",
  GET_REPEATING_ADAPTER_TOKENS_FAIL = "GET_REPEATING_ADAPTER_TOKENS_FAIL",

  SAVE_TEMPLATE_RULE = "SAVE_TEMPLATE_RULE",
  SAVE_TEMPLATE_RULE_SUCCESS = "SAVE_TEMPLATE_RULE_SUCCESS",
  SAVE_TEMPLATE_RULE_FAIL = "SAVE_TEMPLATE_RULE_FAIL",

  GET_TEMPLATE_RULES = "GET_TEMPLATE_RULES",
  GET_TEMPLATE_RULES_SUCCESS = "GET_TEMPLATE_RULES_SUCCESS",
  GET_TEMPLATE_RULES_FAIL = "GET_TEMPLATE_RULES_FAIL",
  MANAGE_EDITOR_DRAWER = "MANAGE_EDITOR_DRAWER",
  RESET_TEMPLATE_RULES = "RESET_TEMPLATE_RULES",

  GET_PREVIEW_DATA = "GET_PREVIEW_DATA",
  GET_PREVIEW_DATA_SUCCESS = "GET_PREVIEW_DATA_SUCCESS",
  GET_PREVIEW_DATA_FAIL = "GET_PREVIEW_DATA_FAIL",
  RESET_PREVIEW_DATA = "RESET_PREVIEW_DATA",

  GET_REPEATING_ADAPTERS = "GET_REPEATING_ADAPTERS",
  GET_REPEATING_ADAPTERS_SUCCESS = "GET_REPEATING_ADAPTERS_SUCCESS",
  GET_REPEATING_ADAPTERS_FAIL = "GET_REPEATING_ADAPTERS_FAIL",

  SET_EDITOR_SETTINGS = "SET_EDITOR_SETTINGS",
  SET_EDITOR_SETTINGS_SUCCESS = "SET_EDITOR_SETTINGS_SUCCESS",
  SET_EDITOR_SETTINGS_FAIL = "SET_EDITOR_SETTINGS_FAIL",

  UPDATE_SECTION_EDITOR = "UPDATE_SECTION_EDITOR",

  GET_TEMPLATE_PREVIEW = "GET_TEMPLATE_PREVIEW",
  GET_TEMPLATE_PREVIEW_SUCCESS = "GET_TEMPLATE_PREVIEW_SUCCESS",
  GET_TEMPLATE_PREVIEW_FAIL = "GET_TEMPLATE_PREVIEW_FAIL",

  RESET_TEMPLATE_PREVIEW = "RESET_TEMPLATE_PREVIEW",
}
